import ProfileScreen from './Profile';

export {ProfileScreen};
